export default from './post-page';



// WEBPACK FOOTER //
// ./app/containers/post-page/index.js